
import noEmpty from '~/components/j/noEmpty.vue'
import { debounce } from '~/utils/utils'
export default {
  components: {
    'no-empty': noEmpty
  },
  data() {
    return {
      is_show: false,
      content: '',
      listData: [],
      listTotal: 0,
      pageIndex: 1,
      loadShow: false
    }
  },
  mounted() {
    if (this.is_show) {
      document.body.style.overflow = 'hidden'
    }
  },
  methods: {
    search() {
      // 点击搜索
      if (!this.content) {
        this.$message({
          message: this.$v('请输入查询内容'),
          type: 'warning'
        })
      }
      this.pageIndex = 1
      this.listData = []
      this.listTotal = 0
      this.listfn()
    },
    scrollFn() {
      // 滚动加载数据
      const scroll = document.getElementById('search-list')
      const scrollId = document.getElementById('search-id')
      scroll.addEventListener(
        'scroll',
        debounce((e) => {
          const height = scroll.clientHeight
          const ulHeight = scrollId.clientHeight
          const scrollTop = e[0].target.scrollTop
          const numHeiht = ulHeight - height - scrollTop
          if (numHeiht <= 0) {
            // 滚动条拉到底部
            if (this.listData.length >= this.listTotal) return
            this.pageIndex++
            this.loadShow = true
            this.listfn()
          }
        }, 1000),
        { passive: true }
      )
    },
    listfn() {
      // 请求数据
      this.$api.list
        .searchlist({
          content: this.content,
          pageIndex: this.pageIndex,
          pageSize: 20
        })
        .then((res) => {
          this.loadShow = false
          if (!res.items || res.items.length == 0) return
          res.items.forEach((res) => {
            this.listData.push(res)
          })
          this.listTotal = res.total
          // fw.tranUtcTime('j-formattime5', 'time-sc') // 格式化时间
        })
        .catch(() => {
          console.log('searchlist')
        })
    },
    open() {
      // 打开手机弹框
      this.is_show = true
      document.body.style.overflow = 'hidden'
      this.$nextTick(() => {
        this.scrollFn()
      })
    },
    close() {
      // 关闭搜索弹框
      this.is_show = false
      document.body.style.overflow = 'auto'
    }
  }
}
